<template>
  <div class="display-2 font-weight-light col col-12 text-left text--primary pa-0 mb-8">
    {{ subheading }}
    <template v-if="text">
      — <span
        class="subtitle-1 grey--text"
        v-text="text"
      />
    </template>

    <div class="pt-2">
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Subheading',

    props: {
      subheading: {
        type: String,
        default: '',
      },
      text: {
        type: String,
        default: '',
      },
    },
  }
</script>
